
import {
  Box,
  Typography,
  Stepper,
  Step,
  StepLabel,
  IconButton,
  alpha,
  LinearProgress,
  useTheme,
} from '@mui/material';
import {
  ArrowBack as ArrowBackIcon,
  Business as BusinessIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { usePropertyInventory } from '../../../../hooks/usePropertyInventory';
import { useMediaQuery } from '@mui/system';
import { Step1ComplexData } from './steps/Step1ComplexData';
import { Step2ConfigureApartments } from './steps/Step2ConfigureApartments';
import { Step5Summary } from './steps/Step5Summary';

const CreatePropertyLayout = () => {
  const { currentStep } = usePropertyInventory();
  const navigate = useNavigate();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const steps = [
    'Datos del Complejo',
    'Confirmación del Complejo',
    'Resumen Final'
  ];

  return (
    <Box sx={{ backgroundColor: 'white', minHeight: '100vh' }}>
      {/* Header */}
      <Box sx={{ 
        p: 3, 
        borderBottom: '1px solid #E0E0E0',
        backgroundColor: 'white',
        mb: 3 
      }}>
        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
            <IconButton
              sx={{ 
                mr: 2,
                backgroundColor: alpha('#4DB6AC', 0.1),
                '&:hover': {
                  backgroundColor: alpha('#4DB6AC', 0.2),
                }
              }}
              onClick={() => navigate(-1)}
            >
              <ArrowBackIcon sx={{ color: '#4DB6AC' }} />
            </IconButton>
            <BusinessIcon sx={{ mr: 2, color: '#4DB6AC' }} />
            <Typography variant="h5" component="div" fontWeight="bold" color="#2E7D7A">
              Crear Nueva Propiedad
            </Typography>
          </Box>

          {/* Stepper adaptativo */}
          <Stepper 
            activeStep={currentStep} 
            orientation={isMobile ? "vertical" : "horizontal"} 
            alternativeLabel={!isMobile}
            sx={{ mb: 2 }}
          >
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel
                  sx={{
                    '& .MuiStepLabel-label': {
                      color: '#666',
                      fontSize: '0.875rem'
                    },
                    '& .MuiStepLabel-label.Mui-active': {
                      color: '#2E7D7A',
                      fontWeight: 'bold'
                    },
                    '& .MuiStepLabel-label.Mui-completed': {
                      color: '#4DB6AC'
                    }
                  }}
                >
                  {label}
                </StepLabel>
              </Step>
            ))}
          </Stepper>

          {/* Barra de progreso */}
          <LinearProgress 
            variant="determinate" 
            value={((currentStep + 1) / steps.length) * 100}
            sx={{
              height: 6,
              borderRadius: 3,
              backgroundColor: alpha('#4DB6AC', 0.2),
              '& .MuiLinearProgress-bar': {
                backgroundColor: '#4DB6AC',
                borderRadius: 3,
              }
            }}
          />
        </Box>
      </Box>

      {/* Contenido del paso actual */}
      <Box>
        <StepContent />
      </Box>
    </Box>
  );
};
// Componente que renderiza el contenido según el paso actual
const StepContent = () => {
  const { currentStep } = usePropertyInventory();

  const renderStep = () => {
    switch (currentStep) {
      case 0:
        return <Step1ComplexData />;
      case 1:
        return <Step2ConfigureApartments />;
      case 2:
        return <Step5Summary />;
      default:
        return <Step1ComplexData />;
    }
  };

  return renderStep();
};

export default CreatePropertyLayout;